import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import BaseContainer from "@base/container/BaseContainer";
import BackgroundContainer from "./BackgroundContainer";
import BigWinContainer from "./BigWinContainer";
import {Signals, SymbolsContainer} from "@/Imports";
import Config from "../config/Config";
import ScaleManager from "@/stage/ScaleManager";
import FreespinsIntroContainer from "@/containers/FreespinsIntroContainer";
import AnticipationContainer from "@/containers/AnticipationContainer";
import FreespinsOutroContainer from "@/containers/FreespinsOutroContainer";
import FreespinsBuyContainer from "@/containers/FreespinsBuyContainer";
//import InterimWinNumbersContainer from "@/containers/InterimWinNumberContainer";
import MultiplierContainer from "@/containers/MultiplierContainer";
import BuyFeatureContainer from "@/containers/BuyFeatureContainer";
import BuyButtonContainer from "@/containers/BuyButtonContainer";


export default class MainContainer extends BaseContainer {

  constructor(dataField) {
    super()
    Facade.mainContainer = this
    this.dataField = dataField
    this.init()
    this.interactive = false
  }

  init() {
    Signals.startAnticipation.add(this.onStartAnticipation, this);
    Signals.stopAnticipation.add(this.onStopAnticipation, this);

    Signals.showBigWin.add(this.hideAllSymbols, this)
    Signals.showBonusOutroComplete.add(this.showAllSymbols, this)

    Signals.introFreespins.add(this.hideSymbols, this)
    Signals.introFreespinsComplete.add(this.showSymbols, this)

    Signals.outroFreespins.add(this.hideSymbols, this)
    Signals.outroFreespinsComplete.add(this.showSymbols, this)

    Signals.buyFreespins.add(this.hideSymbols, this)
    Signals.buyFreespinsComplete.add(this.showSymbols, this)

    Config.reelsObject = {x: 930, y: 915}

    //Creation back layer
    this.background = new BackgroundContainer()
    this.addChild(this.background)

    //Creation symbols layer
    this.symbolsContainer = new SymbolsContainer(this.dataField)
    this.symbolsContainer.interactive = true
    this.addChild(this.symbolsContainer)

    this.multiplierContainer = new MultiplierContainer()
    this.addChild(this.multiplierContainer)

    //this.decorationContainer = new DecorationContainer()
    //this.addChild(this.decorationContainer)

    if(Facade.model.buyFreebet.length > 0){
      this.buyButtonContainer = new BuyButtonContainer()
      this.addChild(this.buyButtonContainer)
    }

    this.freespinsIntroContainer = new FreespinsIntroContainer()
    this.addChild(this.freespinsIntroContainer)

    this.freespinsBuyContainer = new FreespinsBuyContainer()
    this.addChild(this.freespinsBuyContainer)

    this.freespinsOutroContainer = new FreespinsOutroContainer()
    this.addChild(this.freespinsOutroContainer)

    this.buyFeature = new BuyFeatureContainer()
    this.addChild(this.buyFeature)
    //   this.buyFeature.build()

    // this.animationsContainer = new AnimationsContainer()
    // this.addChild(this.animationsContainer)

    // this.interimWinNumbersContainer = new InterimWinNumbersContainer()
    // this.addChild(this.interimWinNumbersContainer)

    this.bigWinContainer = new BigWinContainer()
    this.addChild(this.bigWinContainer)
    this.bigWinContainer.y -= 155

    // this.anticipationContainer = new AnticipationContainer()
    // this.addChild(this.anticipationContainer)

    this.uiContainer = new PIXI.Container()
    this.addChild(this.uiContainer)

    this.uiMenuContainer = new PIXI.Container()
    this.addChild(this.uiMenuContainer)

    this.RealsPosition = {x: 930, y: 915}

    this.symbolsContainer.x = this.RealsPosition.x + 20
    this.symbolsContainer.y = this.RealsPosition.y + 10
    // this.anticipationContainer.x = this.RealsPosition.x
    // this.anticipationContainer.y = this.RealsPosition.y
    // Utils.applyFromPattern (this.interimWinNumbersContainer, Config.pattern.reels)

    //this.createSymbolMask (Config.pattern.machineMask)
    this.createSymbolMask ({x: 890,y: 865, width: 1100,height: 916})


    window.dispatchEvent(new Event('resize'))
    this.onOrientationChanged(Facade.orientation)

    Signals.graphicsCreated.dispatch()
    window.dispatchEvent(new Event('resize'))
  }

  onOrientationChanged(orientationSymbol) {
    this.freespinsIntroContainer.position.set(ScaleManager.center.x, ScaleManager.center.y )
    this.freespinsOutroContainer.position.set(ScaleManager.center.x, ScaleManager.center.y )
    this.freespinsBuyContainer.position.set(ScaleManager.center.x, ScaleManager.center.y )
    switch (orientationSymbol) {
      case 'Hd':
       // this.background.y = 0;
        break;
      case 'Hm':
       // this.background.y = 0
        break
      case 'Vm':
       // this.background.y = 100;
        break
    }
  }

  createSymbolMask(maskPattern) {
    if(this.symbolsMask) {
      this.symbolsMask.clear()
    }
    this.symbolsMask = new PIXI.Graphics()
    this.symbolsMask.name = 'graphics #17';
    this.symbolsMask.beginFill(0x0FF000)
    this.symbolsMask.drawRect(-40, -60, maskPattern.width + 10, maskPattern.height + 5)
    this.symbolsMask.endFill()
    this.symbolsContainer.mask = this.symbolsMask
    this.symbolsMask.x = maskPattern.x
    this.symbolsMask.y = maskPattern.y + 10
    this.addChild(this.symbolsMask)

    this.generalMask = new PIXI.Graphics()
    this.generalMask.name = 'graphics #18';
    this.generalMask.beginFill(0xffffff)
    const x = Math.ceil(ScaleManager.currentSizes.total.width - 2570)/2
    this.generalMask.drawRect(x, 0,  2565, ScaleManager.currentSizes.total.height)
    this.generalMask.endFill()
    this.mask = this.generalMask
    this.addChild(this.generalMask)
  }

  hideAllSymbols() {
    this.symbolsContainer.visible = false
  }

  showAllSymbols() {
    this.symbolsContainer.visible = true
  }

  onStartAnticipation(columnIndex) {
    // this.anticipationContainer.playAnticipation(columnIndex);
  }

  onStopAnticipation() {
    // this.anticipationContainer.stopAnticipation();
  }

  hideSymbols() {
    this.symbolsContainer.visible = false
  }

  showSymbols() {
    this.symbolsContainer.visible = true
  }

}
